import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const settingGeneralService = { constants, slice, sagas };

export default settingGeneralService;

